var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 4,
    r: 1.1,
    fill: "#00FFFF",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.42,
    cy: 4.6,
    r: 1.3,
    fill: "#00FFFF",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.43,
    cy: 6.34,
    r: 1,
    fill: "#00FFFF",
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.66,
    cy: 9,
    r: 1.4,
    fill: "#00FFFF",
    opacity: 0.95
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.85,
    cy: 12.26,
    r: 1.2,
    fill: "#00FFFF",
    opacity: 0.85
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.85,
    cy: 15.74,
    r: 1.5,
    fill: "#00FFFF",
    opacity: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.66,
    cy: 19,
    r: 1.1,
    fill: "#00FFFF",
    opacity: 0.75
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.43,
    cy: 21.66,
    r: 1.35,
    fill: "#00FFFF",
    opacity: 0.9
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.42,
    cy: 23.4,
    r: 0.9,
    fill: "#00FFFF",
    opacity: 0.6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 24,
    r: 1.2,
    fill: "#00FFFF",
    opacity: 0.8
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.58,
    cy: 23.4,
    r: 1.4,
    fill: "#00FFFF",
    opacity: 0.92
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.57,
    cy: 21.66,
    r: 1,
    fill: "#00FFFF",
    opacity: 0.68
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.34,
    cy: 19,
    r: 1.3,
    fill: "#00FFFF",
    opacity: 0.85
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.15,
    cy: 15.74,
    r: 1.1,
    fill: "#00FFFF",
    opacity: 0.75
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.15,
    cy: 12.26,
    r: 1.45,
    fill: "#00FFFF",
    opacity: 0.95
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.34,
    cy: 9,
    r: 0.95,
    fill: "#00FFFF",
    opacity: 0.65
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.57,
    cy: 6.34,
    r: 1.25,
    fill: "#00FFFF",
    opacity: 0.88
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.58,
    cy: 4.6,
    r: 1.1,
    fill: "#00FFFF",
    opacity: 0.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.22cf2ed84dc920e9cb2fa8e29b632be5.svg";
export { ForwardRef as ReactComponent };